<template>
  <header class="header" :class="`${isScroll ? 'header-scroll' : ''}`">
      <router-link to="/" class="header-logo">
          <img src="@/assets/img/logo.png" alt="" class="full">
          <img src="@/assets/img/logo_red.png" alt="" class="simple">
      </router-link>
      <div style="display:flex;align-items:center;height:100%;" class="com-menu">
        <div class="header-menu">
            <router-link 
                class="header-menu-item"
                v-for="(routeItem,index) in routeList" 
                :key="index"
                :class="`${$route.name == routeItem.name ? 'active' : ''}`"
                :to="routeItem.link" >
                {{ routeItem.title }}
            </router-link>
        </div>
        <div class="header-phone">热线：18321223168</div>
      </div>
      <!-- pad端及较小的屏幕 -->
        <div class="hamburger" id="hamburger" :class="{'hamburger-scroll' : isScroll ,'is-active':isHamburgerActive }" @click="isHamburgerActive = !isHamburgerActive">
            <span class="line"></span>
            <span class="line"></span>
            <span class="line"></span>
        </div>
        <div class="phone-menu" :class="`${isScroll ? 'header-scroll' : ''}`" v-show="isHamburgerActive">
            <span 
                class="phone-menu-item"
                v-for="(routeItem,index) in routeList" 
                :key="index"
                :class="`${$route.name == routeItem.name ? 'active' : ''}`"
                @click="isHamburgerActive = false ; $router.push(routeItem.link)" >
                {{ routeItem.title }}
            </span>
        </div>
  </header>
</template>
<script>
export default {
    name:'headerComponent',
    data () {
        return {
            scrollTop:0,
            routeList:[{
                name:'Home',
                title:'网站首页',
                link:{name:'Home'}
            },{
                name:'NewsList',
                title:'相关资讯',
                link:{name:'NewsList'}
            },{
                name:'Introduction',
                title:'公司介绍',
                link:{name:'Introduction'}
            },{
                name:'Partner',
                title:'事业合伙人',
                link:{name:'Partner'}
            },{
                name:'About',
                title:'关于我们',
                link:{name:'About'}
            }],
            isHamburgerActive:false 
        }
    },
    mounted(){
        window.addEventListener('scroll',(e)=>{
            this.scrollTop = document.documentElement.scrollTop;
        },false)
    },
    computed:{
        isScroll(){
            return this.scrollTop > 0 ? true : false
        }
    },
    methods:{
        scrollEvent(){

        }
    }
}
</script>
<style lang="scss" scoped>
.hamburger{
    display: none;
}
.hamburger .line{
  width: 30px;
  height: 3px;
  background-color: #ecf0f1;
  display: block;
  margin: 5px auto;
  -webkit-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}
.hamburger-scroll .line{
  background-color: $base-color;
}
.hamburger:hover{
  cursor: pointer;
}
.header{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 75px;
    min-width: 1200px;
    padding:0 20px;
    box-sizing: border-box;
    background: rgba($color: #000000, $alpha: .3);
    z-index: 1000;
    @include flexMode(center,space-between,row);
    transition: all .5s ease-in-out;
    &-logo{
        height: 55px;
        display: block;
        img{
            height: 100%;
            &.simple{
                display: none;
            }
        }
    }
    &-menu{
        height: 100%;
        &-item{
            display: inline-block;
            height: 100%;
            color: #000;
            padding: 0 40px;
            line-height: 75px;
            position: relative;
            color: #fff;
            &.active::after,&:hover::after{
                content: '';
                position: absolute;
                left: 40px;
                right: 40px;
                bottom: 0;
                height: 2px;
                background: #fff;
            }
        }
    }
    &-phone{
        color: #fff;
        margin-left: 40px;
    }
    &-scroll{
        background:#fff !important;
        box-shadow: 0 0 15px 0 rgba($color: #000000, $alpha: .3);
        transition: all .5s ease-in-out;
        .header-menu-item{
            color: #000;
            &.active,&:hover{
                color: $base-color;                
            }
            &.active::after,&:hover::after{
                background: $base-color;
                color: $base-color;
            }
        }
        .header-phone{
            color: #000;
        }
    }
}
#hamburger.is-active{
  -webkit-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  -o-transform: rotate(90deg);
  transform: rotate(90deg);
}

#hamburger.is-active .line:nth-child(2){
  -webkit-transition: none;
  -o-transition: none;
  transition: none;
}

#hamburger .line:nth-child(2){
  -webkit-transition-delay: 0.3s;
  -o-transition-delay: 0.3s;
  transition-delay: 0.3s;
}


#hamburger.is-active .line:nth-child(2){
  opacity: 0;
}

#hamburger.is-active .line:nth-child(1),
#hamburger.is-active .line:nth-child(3){
  width: 20px;
  -webkit-transform-origin: right;
  -moz-transform-origin: right;
  -ms-transform-origin: right;
  -o-transform-origin: right;
  transform-origin: right;
}

#hamburger.is-active .line:nth-child(1){
  transform: translateY(9px) rotate(45deg);
}

#hamburger.is-active .line:nth-child(3){
  transform: translateY(-9px) rotate(-45deg);
}
//移动端和ipad
@media only screen and (max-width: $screen-sm-min){
    .header{
        min-width: 100%;
        height: 50px;
    }
    .com-menu{
        display: none !important;
    }
    .hamburger{
        display: block;
    }
    // .simple{
    //     display: block !important;
    // }
    // .full{
    //     display: none;
    // }
    .header-logo{
        height: 40px;
    }
    .header-scroll{
        box-shadow:none !important;
    }
    .phone-menu{
        position: absolute;
        left: 0;
        right: 0;
        top:50px;
        background: rgba(0, 0, 0, 0.3);
        &-item{
            color: #fff;
            display: block;
            padding: 10px 15px;
            box-sizing: border-box;
            border-top: 1px solid #eee;
            cursor: pointer;
        }
        &.header-scroll{
            &>span{
                color: $base-color;
            }
        }
    }
} 
//中型屏幕
@media only screen and (max-width: $screen-lg-min){
    .header{
        min-width: 100%;
        &-phone{
            display: none;
        }
    }
    .com-menu{
        // display: none !important;
    }
} 
</style>